import { ValidationResult } from './types';

function isValidObservation(obj: Record<string, unknown>): boolean {
  return obj.resourceType === 'Observation' && obj.code !== undefined;
}

export function validateFhirData(data: any): ValidationResult {
  const errors: string[] = [];

  const { resourceType } = data;

  if (!resourceType || typeof resourceType !== 'string') {
    return { isValid: false, error: 'ResourceType is missing or invalid' };
  }

  // Validate Bundle
  if (resourceType === 'Bundle') {
    if (!data.entry || !Array.isArray(data.entry)) {
      return {
        isValid: false,
        error: 'Bundle must have an "entry" field that is an array',
      };
    }

    const observations = data.entry.filter(
      (entry: any) => entry?.resource?.resourceType === 'Observation',
    );

    if (observations.length === 0) {
      return {
        isValid: false,
        error: 'No Observation resources found in Bundle',
      };
    }

    return { isValid: true };
  }

  // Validate single Observation
  if (resourceType === 'Observation') {
    if (!data.code) {
      return { isValid: false, error: 'Observation must have a "code" field' };
    }

    return { isValid: true };
  }

  return {
    isValid: false,
    error: `Unsupported resource type: "${resourceType}". Expected "Bundle" or "Observation"`,
  };
}
